import { Box, Flex, Grid, Text } from '@chakra-ui/react';
import { Layout } from '../Layout';

interface VideoCardProps {
  title: string;
  subtitle: string;
  src: string;
  poster: string;
}

const VideoCard: React.FC<VideoCardProps> = ({ title, subtitle, src, poster }) => (
  <Box
    bgColor="white"
    border="0.5px solid #E2E8F0"
    borderRadius="xl"
    boxShadow="rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px"
    overflow="hidden"
    transition="box-shadow 0.2s ease"
    _hover={{ boxShadow: 'rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.08) 0px 16px 48px' }}
  >
    <Box px={6} pt={6} pb={0}>
      <Text color="#b44e50" fontWeight="800" fontSize="sm" letterSpacing=".1em">
        {title.toUpperCase()}
      </Text>
      <Box mt={2} mb={4} height="3px" bgColor="#940104" width="100%" borderRadius="full" />
      {/* <Text mt={3} mb={4} color="#6b6b67" fontSize="sm" fontWeight={500}>
        {subtitle}
      </Text> */}
    </Box>

    <Box px={6} pb={6}>
      <Box
        borderRadius="lg"
        overflow="hidden"
        boxShadow="rgba(0,0,0,0.08) 0px 2px 12px"
        sx={{ aspectRatio: '16 / 9' }}
      >
        <video
          src={src}
          poster={poster}
          controls
          preload="none"
          controlsList="nodownload"
          onContextMenu={(e) => e.preventDefault()}
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      </Box>
    </Box>
  </Box>
);

function Rectorat() {
  return (
    <Layout>
      <Text
        mt="60px"
        fontWeight="900"
        color="#b3b3af"
        fontSize={['4xl', '4xl', '5xl']}
        letterSpacing="-.1rem"
        cursor="default"
      >
        Séance d'échange rectorale
      </Text>

      <Text mb={6} ps={1} color="#6b6b67" fontSize="md" fontWeight={500}>
        Enregistrements des séances d'échange entre l'ADERE et les candidat·es à l'élection rectorale
        de l'Université de Liège — 15 avril 2026.
      </Text>

      <Box mb={10} height="4px" bgColor="#940104" width="100%" />

      <Flex minH="55vh" align="center" justify="center" pb={16}>
        <Grid
          templateColumns={['1fr', '1fr', '1fr 1fr']}
          gap={8}
          width="100%"
        >
          <VideoCard
            title="Anne-Sophie Nyssen"
            subtitle="Candidate à l'élection rectorale — ULiège"
            src="/rectorat/nyssen_fixed.mp4"
            poster="/rectorat/nyssen_poster.jpg"
          />
          <VideoCard
            title="Damien Ernst"
            subtitle="Candidat à l'élection rectorale — ULiège"
            src="/rectorat/ernst_fixed.mp4"
            poster="/rectorat/ernst_poster.jpg"
          />
        </Grid>
      </Flex>
      <Box height={'150px'}></Box>
    </Layout>
  );
}

export default Rectorat;
